module.exports = __webpack_public_path__ + "static/standalone/img/product-government.b79b5666.svg";